import { Button, Icon } from '@nazka/nazka.mapframe.components';
import Nav from '@App/components/Nav/Nav';

import './about.styl';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

function About() {
  function handleQuestionClick(e) {
    const clickedElement = e.currentTarget.parentElement;
    clickedElement.classList.toggle('show');
  }

  return (
    <div className="about">
      <Nav />
      <div className="about__line" />
      <div className="about__body">
        <div className="about__body__nav">
          <Button
            className="about__body__nav__button"
            layout="ghost"
            themeColor="secondary"
            onClick={() => {
              document.getElementById('about-naarjobs').scrollIntoView({
                behavior: 'smooth',
              });
            }}
          >
            Over NaarJobs
          </Button>
          <div className="about__body__nav__submenu">
            <Button
              className="about__body__nav__button"
              layout="ghost"
              themeColor="secondary"
              onClick={() => {
                document.getElementById('about-naarjobs-why-develop').scrollIntoView({
                  behavior: 'smooth',
                });
              }}
            >
              Waarom werd NaarJobs ontwikkeld?
            </Button>
            <Button
              className="about__body__nav__button"
              layout="ghost"
              themeColor="secondary"
              onClick={() => {
                document.getElementById('about-naarjobs-from-flanders-to-belgium').scrollIntoView({
                  behavior: 'smooth',
                });
              }}
            >
              Van naarjobsinwestvlaanderen.be tot naarjobs.be
            </Button>
            <Button
              className="about__body__nav__button"
              layout="ghost"
              themeColor="secondary"
              onClick={() => {
                document.getElementById('about-naarjobs-jobcoach').scrollIntoView({
                  behavior: 'smooth',
                });
              }}
            >
              Wat heeft NaarJobs jou als jobcoach te bieden?
            </Button>
            <Button
              className="about__body__nav__button"
              layout="ghost"
              themeColor="secondary"
              onClick={() => {
                document.getElementById('about-naarjobs-life-work-mobility').scrollIntoView({
                  behavior: 'smooth',
                });
              }}
            >
              Hoe kan je als werkgever woon-werk mobiliteit ondersteunen?
            </Button>
            <Button
              className="about__body__nav__button"
              layout="ghost"
              themeColor="secondary"
              onClick={() => {
                document.getElementById('about-naarjobs-datasources').scrollIntoView({
                  behavior: 'smooth',
                });
              }}
            >
              Databronnen
            </Button>
          </div>
          <Button
            className="about__body__nav__button"
            layout="ghost"
            themeColor="secondary"
            onClick={() => {
              document.getElementById('about-mobility').scrollIntoView({
                behavior: 'smooth',
              });
            }}
          >
            Over het mobiliteitsaanbod
          </Button>
          <Button
            className="about__body__nav__button"
            layout="ghost"
            themeColor="secondary"
            onClick={() => {
              document.getElementById('more-help').scrollIntoView({
                behavior: 'smooth',
              });
            }}
          >
            Meer hulp nodig?
          </Button>
          <Button
            className="about__body__nav__button"
            layout="ghost"
            themeColor="secondary"
            onClick={() => {
              document.getElementById('faq').scrollIntoView({
                behavior: 'smooth',
              });
            }}
          >
            Vaakgestelde vragen
          </Button>
        </div>
        <div className="about__body__text">
          <h1 id="about-naarjobs">Over NaarJobs</h1>
          <p>
            Wie een job zoekt, kan hier makkelijk de jobs in zijn of haar buurt zien én ontdekken 
            hoe je er op een makkelijke en duurzame manier geraakt. Jobcoaches hebben met NaarJobs 
            ook een extra tool in handen om werkzoekenden te helpen mobiliteitsdrempels te overwinnen. 
            Werkgevers kunnen dan weer hun mobiliteitsaanbod in de verf zetten.
          </p>
          <h2 id="about-naarjobs-why-develop">Waarom werd NaarJobs ontwikkeld?</h2>
          <p>
            Het gebrek aan mobiliteit of aan kennis over de bestaande vervoersmogelijkheden 
            is een belangrijke drempel in de zoektocht naar werk in Vlaanderen.
          </p>
          <p>NaarJobs brengt daar verandering in:</p>
          <ul>
            <li>
              Door vacatures letterlijk op de kaart te zetten en alle relevante mobiliteitsinformatie 
              te bundelen per onderneming.
            </li>
            <li>
              Door alle vervoersopties (te voet, fiets, openbaar vervoer of een combinatie) te tonen om 
              een tewerkstellings- of sollicitatieadres te bereiken.
            </li>
            <li>
              Door het mobiliteitsaanbod van werkgevers in de kijker te zetten via een handige zoek- en filterfunctie.
            </li>
          </ul>
          <p>
            NaarJobs toont hoe je slim en duurzaam op je nieuwe of huidige job kan geraken, en hoe je (nieuwe) 
            werkgever dit kan ondersteunen. Zo gaan we samen op weg naar jouw bereikbare job.
          </p>
          <h2 id="about-naarjobs-from-flanders-to-belgium">Van naarjobsinwestvlaanderen.be tot naarjobs.be</h2>
          <p>
            NaarJobs is het resultaat van een innovatief traject sinds 2018 met cruciale arbeidsmarktpartners. 
            De uitdaging startte voor de haven van Antwerpen samen met de dienst Economie van de stad en VDAB Antwerpen. 
            Het eerste concept werd verder ontwikkeld in West-Vlaanderen met de onmisbare steun van de POM West-Vlaanderen, 
            VDAB West-Vlaanderen, het bedrijventerrein van Plassendale, de haven van Zeebrugge en de feedback van vele 
            jobcoaches, vakbonden en sectorfederaties. Het opschalen van naarjobsinwestvlaanderen.be tot naarjobs.be zette 
            dezelfde samenwerkingsvisie van co-creatie verder, dankzij middelen van de FOD Mobiliteit.
          </p>
          <div style={{
            display: 'flex', flexWrap: 'wrap', gap: '40px', alignItems: 'center', padding: '20px 0',
          }}
          >
            <img src="/img/about/traject.png" width={360} />
            <img src="/img/about/partners.png" width={400} />
          </div>
          <h2 id="about-naarjobs-jobcoach">Wat heeft NaarJobs jou als jobcoach te bieden?</h2>
          <p>
            Jobcoaches hebben naast alle voordelen hierboven ook extra troeven in de hand om mensen te begeleiden 
            naar een geschikte job:
          </p>
          <ul>
            <li>
              Als jobcoach kan je op alle bedrijven in de regio zoeken, niet enkel die met een job. 
              Niet alle adressen worden steeds gepubliceerd, maar jij weet soms wel bij welk bedrijf 
              een vacature hoort. Door op bedrijf te kunnen zoeken, kan je samen met de werkzoekende 
              de vervoersopties er naar toe bekijken.
            </li>
            <li>
              Werkplek en sollicitatieadres willen wel eens verschillen. Jij kan als jobcoach dit onderscheid 
              zien en de routes naar beide met de werkzoekende bespreken.
            </li>
            <li>
              Je kan ook routes met de auto berekenen. In de gewone app zit deze optie niet, omdat we iedereen 
              willen stimuleren om met de fiets of openbaar vervoer te gaan. Maar voor sommige werkzoekenden is 
              dit echt een keuze die ze niet zomaar kunnen maken.
            </li>
          </ul>
          <p>
            De tool is helemaal gratis in gebruik, we vragen enkel dat je je registreert. 
            Zo hebben wij een beter beeld van wie we helpen.
          </p>
          <h2 id="about-naarjobs-life-work-mobility">Hoe kan je als werkgever woon-werk mobiliteit ondersteunen?</h2>
          <p>
            Bereikbare jobs zijn aantrekkelijker dan jobs die minder gemakkelijk bereikbaar zijn. 
            Werkgevers kunnen woon-werk mobiliteit ondersteunen door in te zetten op een divers 
            en duurzaam mobiliteitsaanbod. NaarJobs hanteert hierbij vier categorieën:
          </p>
          <ul>
            <li>Dicht bij huis, zoals telewerken en glijdende uren</li>
            <li>Fiets, zoals fietsvergoeding of een abonnement voor deelfietsen</li>
            <li>Openbaar vervoer: hoe zit het met de terugbetaling van trein of bus</li>
            <li>Auto-moto: zoals georganiseerde carpool of een laadpaal</li>
          </ul>
          <p>
            Per categorie kan je als werkgever aanduiden welke opties van toepassing zijn. 
            Omgekeerd filtert een werkzoekende op de gewenste mobiliteitsvoordelen in de 
            zoektocht naar een job. Op die manier krijgt een (toekomstige) werknemer enkel 
            de jobs te zien die binnen zijn of haar mobiliteitsmogelijkheden passen.
          </p>
          <p>
            Maar elk bedrijf heeft ook een bedrijfs-eigen pagina ter beschikking, 
            die de mobiliteitsopties in de buurt toont. Zo kan je ook je huidige werknemers 
            overtuigen om op een alternatieve manier naar het werk te pendelen. 
            Het overzicht van wat een werkgever kan aanbieden op vlak van woon werkmobiliteit vind je hieronder.
          </p>
          <h2 id="about-naarjobs-datasources">Databronnen</h2>
          <p>
            Vacature-informatie komt momenteel uitsluitend van de open data services van VDAB. 
            Info over ondernemingen halen we uit het VKBO en de Federale Diagnostiek van de FOD Mobiliteit. 
            Mobiliteitsdata via de data services van De Lijn en NMBS, en op fietssnelwegen.be.
          </p>
          <h1 id="about-mobility">Over het mobiliteitsaanbod</h1>
          <p>
            {'Dit overzicht is gebaseerd op een '}
            <a href="https://mobilit.belgium.be/nl/duurzame-mobiliteit/enquetes-en-resultaten/federale-enquete-woon-werkverkeer/federale-enquete-woon" target="_blank" rel="noopener noreferrer">
              enquête
            </a>
            {' van de Federale Overheidsdienst Mobiliteit en Vervoer. Ondernemingen met gemiddeld '}
            meer dan 100 werknemers vullen om de drie jaar hun mobiliteitsaanbod in op deze vragenlijst. 
            Ondernemingen die niet onder deze noemer vallen, starten met een leeg mobiliteitsaanbod. 
            {' Een onderneming die zich registreert via de '}
            <a href="https://naarjobs.be/werkgever" target="_blank" rel="noopener noreferrer">
              werkgeverspagina
            </a>
            {' van NaarJobs kan meteen zelf '}
            aan de slag om het mobiliteitsaanbod aan te vullen of te actualiseren waar nodig.
          </p>
          <h2>Dicht bij huis</h2>
          <h3>Glijdende uren</h3>
          <p>
            De mogelijkheid voor de werknemer om zelf te kiezen wanneer die begint en stopt met werken en 
            wanneer die pauzes neemt binnen de vastgelegde stamtijden en glijtijden.
          </p>
          <h3>Werken op afstand</h3>
          <p>
            De mogelijkheid om één of meerdere dagen per week op een andere locatie dan het vaste kantoorgebouw 
            te werken. Dit kan gaan om werken van thuis, werken vanuit een satellietkantoor of werken vanuit 
            een co-workingspace.
          </p>
          <p>
            Eventueel is er een thuiswerktussenkomst: een vaste vergoeding die wordt betaald voor de kosten en/of 
            gebruikte middelen (pc, internet, ...) voor wie structureel van thuis werkt.
          </p>
          <h3>Verhuispremie</h3>
          <p>
            Een premie die de werknemer ontvangt wanneer die verhuist en dichter bij het werk gaat wonen.
          </p>
          <h2>Fiets en e-bike</h2>
          <h3>Fietsvergoeding</h3>
          <p>
            Een vergoeding per kilometer die aan de werknemer wordt aangeboden voor de fietsverplaatsing 
            tussen woonplaats en werkplek.
          </p>
          <p>
            {'Meer info vind je op '}
            <a href="https://www.fietsersbond.be/fietsvergoeding" target="_blank" rel="noopener noreferrer">
              https://www.fietsersbond.be/fietsvergoeding
            </a>
          </p>
          <h3>Abonnement deelfietsen</h3>
          <p>
            Een abonnement dat aan de werknemer wordt aangeboden voor het gebruik van deelfietsen. 
            Voorbeelden zijn Blue-bike, Donkey Republic, Dott, Bolt, Velo Antwerpen, Hoppy en Nextbike.
          </p>
          <p>
            {'Meer info vind je op '}
            <a href="https://www.waytogo.be/nl/fietsdelen" target="_blank" rel="noopener noreferrer">
              https://www.waytogo.be/nl/fietsdelen
            </a>
          </p>
          <h3>Bedrijfsfietsen</h3>
          <p>
            Een bedrijfsfiets is een fiets die de werkgever ter beschikking stelt aan zijn werknemer. 
            Het kan dan gaan om dienstfietsen (een fiets die ter beschikking van de werknemers staat 
            tijdens de diensturen), persoonlijke leasefietsen (het bedrijf least een fiets voor jou) 
            of persoonlijke bedrijfsfietsen (het bedrijf koopt een fiets die jij persoonlijk kan gebruiken).
          </p>
          <h3>Fietsparkeerplaatsen</h3>
          <p>
            Voor fietsers is het sowieso interessant te weten of ze hun fiets makkelijk kwijt kunnen. 
            Maar voor werknemers met een dure (elektrische) fiets is het vaak ook belangrijk dat er een 
            overdekte en/of beveiligde fietsparking is.
          </p>
          <h3>Douches en kleedkamers</h3>
          <p>Wie van ver komt, heeft graag de mogelijkheid zich om te kleden en/of te douchen op het werk.</p>
          <h3>Fietsherstel en fietsbijstand bij pech</h3>
          <p>
            Is er een fietshersteldienst op het terrein van de werkgever of makkelijk bereikbaar voor 
            de werknemer (bijvoorbeeld mobiel)?
          </p>
          <p>
            Krijgt de werknemer een fietsbijstandsdienst aangeboden in geval van ongevallen en/of andere 
            soorten pech onderweg (batterij, mechanisch defect, lekke banden, …)?
          </p>
          <h3>Laadstations voor elektrische fiets</h3>
          <p>Kan en mag de werknemer de fietsbatterij opladen op het werk.</p>
          <h2>Bus, trein, tram, metro</h2>
          <h3>Collectief vervoer</h3>
          <p>
            Werknemers kunnen gebruik maken van gemeenschappelijk vervoer dat georganiseerd wordt op 
            initiatief van de werkgever of een groep van werkgevers om (een deel van) de verplaatsing 
            tussen de woonplaats en de werkplaats af te leggen. Bijvoorbeeld met minibus, autobus of autocar.
          </p>
          <h3>Openbaar vervoer (deels) terugbetaald</h3>
          <p>
            In welke mate wordt het openbaar vervoer terugbetaald? Volledig, in overeenstemming 
            met CAO 19/9 of niet?
          </p>
          <h2>Auto of moto</h2>
          <h3>Abonnement autodelen</h3>
          <p>
            Een abonnement dat aan de werknemer wordt aangeboden voor het gebruik van deelauto’s. 
            Voorbeelden zijn Cambio, BattMobility, Poppy en Stapp In.
          </p>
          <p>
            {'Meer info vind je op '}
            <a href="https://www.waytogo.be/nl/autodelen " target="_blank" rel="noopener noreferrer">
              https://www.waytogo.be/nl/autodelen
            </a>
          </p>
          <h3>Carpool</h3>
          <p>
            Faciliteer je als werkgever het carpoolen tussen collega’s? Dat kan met een carpooldatabank 
            (intern of extern), gereserveerde parkeerplaatsen voor carpoolers, een terugreisgarantie 
            (geraakt de weknemer sowieso thuis?) of een vergoeding specifiek voor het carpoolen.
          </p>
          <h3>Parkeerplaatsen & laadpalen</h3>
          <p>
            Naast het aantal parkeerplaatsen voor auto’s en bromfietsen op het eigen terrein, 
            is het voor werknemers ook belangrijk te weten of ze hier gratis van gebruik kunnen maken of niet.
          </p>
          <p>
            Zijn er laadpalen op het werk? En kom je als werkgever tussen bij de plaatsing van een laadpaal thuis?
          </p>
          <h3>(Elektrische) bedrijfswagens, tankkaarten en kilometervergoedingen</h3>
          <p>
            Een bedrijfswagen is een voertuig dat deel uitmaakt van het loonpakket van de werknemer 
            (een “salariswagen”). De wagen wordt door de werkgever ter beschikking gesteld en mag ook 
            buiten de werkuren voor privédoeleinden worden gebruikt. Deze zijn tegenwoordig vaak elektrisch.
          </p>
          <p>
            Soms kan een werkgever parkeerplaatsen speciaal voorbehouden voor bedrijfswagens.
          </p>
          <p>
            Bovenop een bedrijfswagen krijgt een werknemer ook vaak een tankkaart, al dan niet met beperkingen. 
            Zo’n tankkaart kan echter ook aangeboden worden voor de eigen wagen in plaats van een bedrijfswagen.
          </p>
          <p>
            Ook kan een bedrijf bedrijfswagens ter beschikking stellen aan werknemers voor een korte periode voor 
            privégebruik, zoals een vakantie of verhuis.
          </p>
          <p>
            Ten slotte kan er in plaats van een bedrijfswagen, ook een compensatie (“kilometervergoeding”) gegeven 
            worden voor het gebruik van het privévoertuig in het kader van woon-werkverkeer.
          </p>
          <h1 id="more-help">Meer hulp nodig?</h1>
          <p>
            Hier vind je inspiratie en extra links naar websites en informatie omtrent werk zoeken, 
            mobiliteit en bereikbaarheid
          </p>
          <h3>Op zoek naar een job</h3>
          <p>
            Hulp nodig bij de voorbereiding van je sollicitatie? Vraag je je af hoe een motivatiebrief 
            of professionele cv er uit moet zien? Of oefen je gewoon graag eens vooraf je sollicitatiegesprek? 
            {' De online sollicitatiecoaches van VDAB staan steeds voor je klaar. Meer info op '}
            <a href="https://www.vdab.be/sollicitatiecoaching" target="_blank" rel="noopener noreferrer">
              https://www.vdab.be/sollicitatiecoaching
            </a>
            .
          </p>
          <p>
            Toch nog nood aan die extra begeleiding of duwtje in de rug? De jobcoaches van VDAB staan voor 
            {' je klaar en helpen je graag op weg. Contacteer hen via '}
            <a href="https://www.vdab.be/loopbaanbegeleiding" target="_blank" rel="noopener noreferrer">
              https://www.vdab.be/loopbaanbegeleiding
            </a>
            .
          </p>
          <h3>Geraak je er niet?</h3>
          <p>
            Mobiliteit is een basisrecht. Deelnemen aan de samenleving betekent dat je op school, werk, dokter 
            of bij vrienden en familie geraakt. Hoe vanzelfsprekend dat ook lijkt, toch is het niet voor iedereen 
            even evident.
          </p>
          <p>
            Blijf jij soms ook thuis omdat je verplaatsing te ingewikkeld lijkt? Of weet je niet waar je 
            {' terechtkan voor je vervoersvragen? Het team van '}
            <a href="https://meermobiel.be" target="_blank" rel="noopener noreferrer">
              meermobiel.be
            </a>
            {' helpt je graag verder, contacteer hen via '}
            <a href="https://meermobiel.be/contactformulier" target="_blank" rel="noopener noreferrer">
              meermobiel.be/contactformulier
            </a>
            . 
          </p>
          <p>
            Ook VDAB helpt je graag verder op weg. Met de trein richting je sollicitatie? Misschien heb jij 
            wel recht op een treinticket aan verminderd tarief? Werkzoekenden die ingeschreven zijn bij VDAB, 
            {' kunnen hier beroep op doen. Neem snel een kijkje op '}
            <a href="https://www.vdab.be/mobiliteit" target="_blank" rel="noopener noreferrer">
              https://www.vdab.be/mobiliteit
            </a>
            .
          </p>
          <h1 id="faq">Vaakgestelde vragen</h1>
          <h2>De locatie van een job</h2>
          <div className="about__collapsable">
            <h3 onClick={handleQuestionClick}>
              <Icon icon={faChevronRight} size="16px" className="about__collapsable__icon" />
              <span>Ik zie jobs die aan een vreemde joblocatie gekoppeld zijn</span>
            </h3>
            <p>
              De jobinformatie die wordt getoond in NaarJobs wordt aangeleverd door de VDAB. Dat maakt NaarJobs 
              kwetsbaar voor fouten die gemaakt worden bij het invullen van het tewerkstellingsadres of 
              sollicitatieadres op de website van VDAB. Zo kan het bijvoorbeeld zijn dat een job voor 
              onthaalouder bij een stedelijke kinderopvang, wordt gepubliceerd op het adres van het gemeentehuis. 
              De job &quot;onthaalouder&quot; wordt dan gepubliceerd op de kaart op de vestiging &quot;gemeentehuis&quot;.
            </p>
            <p>
              Als de VDAB een job publiceert met enkel een postcode en een gemeente, wordt deze door het systeem 
              van NaarJobs gekoppeld aan alle vestigingen voor de betrokken onderneming die binnen de gegeven 
              gemeente liggen. Daarom kan een job op meerdere joblocaties voorkomen.
            </p>
          </div>
          <h2>De route</h2>
          <div className="about__collapsable">
            <h3 onClick={handleQuestionClick}>
              <Icon icon={faChevronRight} size="16px" className="about__collapsable__icon" />
              <span>De routering van Google Maps verschilt soms van de routering die door NaarJobs weergegeven wordt.</span>
            </h3>
            <p>
              Dat kan. Er kan een minimaal verschil zitten tussen de coördinaten die Google Maps gebruikt en de coördinaten 
              die NaarJobs gebruikt om de routes te berekenen. Dat heeft verder geen gevolgen voor de juistheid van deze routes.
            </p>
          </div>
          <div className="about__collapsable">
            <h3 onClick={handleQuestionClick}>
              <Icon icon={faChevronRight} size="16px" className="about__collapsable__icon" />
              <span>Mijn route met de fiets vermeldt ook stukjes te voet</span>
            </h3>
            <p>
              Soms kan een route met de fiets onderbroken worden door stukjes kort wandelen. Dat komt door de data 
              die achter deze berekeningen zit. We willen je namelijk steeds de allersnelste route voorstellen. 
              Omwille van verkeersvrije zones of éénrichtingsstraten, kan het dus voorvallen dat je sneller op 
              je bestemming geraakt door een stukje te wandelen met de fiets aan de hand.
            </p>
          </div>
          <div className="about__collapsable">
            <h3 onClick={handleQuestionClick}>
              <Icon icon={faChevronRight} size="16px" className="about__collapsable__icon" />
              <span>Mijn route met de fiets en openbaar vervoer vermeldt altijd wandelen bij het eindpunt.</span>
            </h3>
            <p>
              Onze routeplanner gaat er bij de combinatie fiets-openbaar vervoer altijd van uit dat je je fiets 
              stalt aan het station of aan de bushalte, en dat je na de bus- of treinrit het laatste stukje wandelt.
            </p>
          </div>
          <h2>Werkgevers</h2>
          <div className="about__collapsable">
            <h3 onClick={handleQuestionClick}>
              <Icon icon={faChevronRight} size="16px" className="about__collapsable__icon" />
              <span>
                De naam die ik zie voor mijn onderneming of vestiging komt niet overeen met de naam die ik verwacht
              </span>
            </h3>
            <p>
              NaarJobs neemt de naam van de onderneming of vestiging over uit de Verrijkte Kruispuntbank Ondernemingen (VKBO). 
              Het is mogelijk dat de VKBO in sommige gevallen verkeerde namen doorgeeft, bij bijvoorbeeld OCMW&apos;s en VZW&apos;s. 
              Ook kan de officiële, geregistreerde, naam van het bedrijf verschillen van de gekende &quot;merknaam&quot;.
            </p>
          </div>
          <div className="about__collapsable">
            <h3 onClick={handleQuestionClick}>
              <Icon icon={faChevronRight} size="16px" className="about__collapsable__icon" />
              <span>Waarom kan ik geen jobs publiceren op NaarJobs?</span>
            </h3>
            <p>
              Wij werken met de open data-service van VDAB. Deze is vrij volledig. Als je job daar verschijnt, 
              verschijnt hij normaal ook op NaarJobs. Is dit niet het geval, contacteer ons dan zeker! 
              Dat wil zeggen dat je een foutje gevonden hebt in onze systemen.
            </p>
          </div>
          <h2>Andere</h2>
          <div className="about__collapsable">
            <h3 onClick={handleQuestionClick}>
              <Icon icon={faChevronRight} size="16px" className="about__collapsable__icon" />
              <span>Kan ik een onderneming of een job bewaren?</span>
            </h3>
            <p>
              Ja, je kan de unieke URL voor een job of zelfs voor een onderneming opslaan onder de favorieten van je browser. 
              Je kan deze unieke URL ook kopiëren en plakken in bijvoorbeeld een mail.
            </p>
          </div>
        </div>
        <div className="about__body__spacing" />
      </div>
    </div>
  );
}

export default About;
